import { connect } from 'react-redux'
import { State } from 'interfaces/state'
import { memberInfoSelector } from 'selectors/globalSelectors'
import internal from 'components/utils/Internal'
import { CreditLinkagePage, CreditLinkagePageStateProps } from 'components/features/pfm/CreditLinkagePage/CreditLinkagePage'

const mapStateToProps = (state: State): CreditLinkagePageStateProps => {
  const member = memberInfoSelector(state)

  return {
    isCreditFileLinked: Boolean(member && member.is_creditfile_linked),
  }
}

export const CreditLinkagePageContainer = internal(
  connect<CreditLinkagePageStateProps>(mapStateToProps)(CreditLinkagePage)
)
